import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6su5v1sirt: FaireBrandEntity = {
  token: "b_6su5v1sirt",
  type: "brand",
  name: "Highwire Coffee Roasters",
  avatarUrl:
    "https://cdn.faire.com/fastly/3092d9237b0556ea5c7677ba105d8da97c32509f06f8c1d7e543a7380d0b1f1d.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/ca26d2813293667d6ebf713379c60a52a2026e44893de75b11c951fa0b05ed6c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3092d9237b0556ea5c7677ba105d8da97c32509f06f8c1d7e543a7380d0b1f1d.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ca26d2813293667d6ebf713379c60a52a2026e44893de75b11c951fa0b05ed6c.jpeg",
  location: "Emeryville, CA, USA",
  minimumOrderDollars: 50,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Robert Myers, Rich Avella and Eric Hashimoto started Highwire Coffee Roasters in 2011 after long careers in coffee working for other folks.\n\nWe wanted to be more welcoming to more people than what we felt 3rd wave coffee shops were generally doing at that time. The guiding idea was we wanted a place we could bring our moms and dads without them feeling alienated or put off by any kind of exclusive feel of our shop. We wanted our long years of coffee experience to show in the expertly sourced, roasted, and served coffee drinks. \n\nBy about 2012, we found a roast point of view that we found satisfying. Balanced between the brightness and sweetness of origin, with the body and mouthfeel the roast can bring out. We paired this with our first logo and brand images designed by a former barista of ours and were on our way.\n\nIn 2016, we launched our sister brand 4track tea as a way to highlight our love of tea, particularly co-founder Rich Avella's. The idea was to center the sensory pleasure innate in tea drinking rather than continuing to link it to health foods, or the traditions that weren't our own. We source classically produced teas of exceptional quality and create our blends in house. \n",
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:03:41.521Z",
    importedBy: "entity-db-cli",
  },
};
